/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyResponse } from '../../models/company-response';

export interface GetFollowerByCompany$Params {
  id: number;
}

export function getFollowerByCompany(http: HttpClient, rootUrl: string, params: GetFollowerByCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyResponse>>> {
  const rb = new RequestBuilder(rootUrl, getFollowerByCompany.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CompanyResponse>>;
    })
  );
}

getFollowerByCompany.PATH = '/api/company/{id}/follower';
